<div class="modal-header">
  <h4 id="approve-edit-proposal-modal" class="modal-title">{{ "Approve" | translate }}</h4>
  <button (click)="cancel()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
  </form>
</div>

<div class="modal-footer">
  <button (click)="cancel()" class="btn btn-outline-secondary" type="button">
    {{ "Cancel" | translate }}
  </button>

  <button
    [class.loading]="loadingService.loading$ | async"
    [disabled]="!form.valid"
    (click)="approve()"
    class="btn btn-success"
    type="button"
  >
    {{ "Approve" | translate }}
  </button>
</div>
